module.exports = __webpack_public_path__ + "img/media_reg_5.95b32ce3.png";